import styled, { css } from 'styled-components';
import { device } from '../../../styles/devices';
import { COLORS, SIZING } from '../../../styles/variables';

interface StyleProps {
  checked?: boolean;
  disabled?: boolean;
}

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-top: 32px;
  margin-top: 8px;
  @media ${device.tablet} {
    padding-top: 24px;
  }
  @media ${device.laptop} {
    padding-top: 32px;
    margin-top: 8px;
  }
`;

export const LabelInput = styled.h4`
  font-family: Audi Type;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.003px;
  color: ${COLORS.grey80};
`;

export const Title = styled.div`
  font-family: Audi Type;
  font-size: 12px;
  line-height: 20px;
  color: ${COLORS.grey60};
  margin: 0 0 ${SIZING.unit(1.5)} 0;
  align-self: flex-start;
  letter-spacing: 0.002px;
  @media ${device.laptopL} {
    font-size: 12px;
    line-height: 20px;
  }
`;

export const CheckBoxList = styled.ul`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding-top: 16px;
  gap: 24px;
`;

export const CheckboxWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0 0;
  flex: 0 0 50%;
  cursor: pointer;
  gap: 8px;
  align-items: flex-start;

  ${({ disabled }: StyleProps) =>
    disabled === true &&
    `pointer-events: none;
     opacity: 0.2;
    `}

  @media ${device.laptop} {
    align-items: flex-start;
  }

  @media ${device.tablet} {
    gap: 12px;
    align-items: flex-start;
  }
`;

export const Checkbox = styled.div`
  width: 20px;
  height: 20px;
  border: ${({ checked }: StyleProps) =>
    checked ? `1px solid ${COLORS.grey80}` : `1px solid ${COLORS.grey60}`};
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

export const Label = styled.label<{ isLegal: boolean | undefined }>`
  /* display: inline-flex; */
  align-items: center;
  flex: 1 1 0;
  font-family: Audi Type;
  font-size: ${({ isLegal }) => (isLegal ? '12px' : '16px')};
  line-height: ${({ isLegal }) => (isLegal ? '20px' : '24px')};
  color: ${COLORS.grey80};
  letter-spacing: 0.003px;
`;

export const SubLabel = styled.label`
  font-family: Audi Type;
  font-size: 12px;
  line-height: 20px;
  color: ${COLORS.grey60};
  letter-spacing: 0.002px;
`;

export const HiddenInput = styled.input`
  display: none;
`;

export const OptionalNote = styled.span`
  font-family: Audi Type;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  color: ${COLORS.grey60};
  letter-spacing: 0.002px;
  margin-left: 4px;
`;
